/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import VueDraggable from 'vue-draggable'
import axios from 'axios'
import VueAxios from 'vue-axios'
import versionApi from "./data/VesrionsApi";
import CStorage from "./data/CStorage";
import VueYandexMetrika from 'vue-yandex-metrika'
import JwtService, {isAuthenticated} from './data/jwt.service'
import VueCookies from 'vue-cookies'
import VueJivosite from '@bchteam/vue-jivosite'
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueMeta from 'vue-meta'
import Clipboard from 'v-clipboard'
import userApi from "./data/UserApi";
import LoadScript from 'vue-plugin-load-script';
import VueGtm from "vue-gtm";
import VueGtag from "vue-gtag";
import i18n, {flavorConfigJson} from './i18n'
import {isAndroid} from "./data/AndroidApi";
import '@fortawesome/fontawesome-free/css/all.css'

Vue.config.productionTip = false

export const eventBus = new Vue();
const UNAUTHORIZED = 401

if (JwtService.getToken()) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${JwtService.getToken()}`
} else {
    delete axios.defaults.headers.common['Authorization']
}

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL
Vue.use(VueCookies)
Vue.use(ArgonDashboard)
Vue.use(VueDraggable)


/* if (!isAndroid()) {
    Vue.use(VueJivosite, {
        widgetId: i18n.t('jivoId'),
        onInit(payload) {
            //console.log('VueJivosite Success!', payload)
            setTimeout(() => {
                if (window.jivo_api) {
                    Vue.$jivosite = window.jivo_api
                    Vue.prototype.$jivosite = window.jivo_api
                    const user = JwtService.getUser()
                    if (JwtService.isAuthenticated() && user) {
                        Vue.$jivosite.setContactInfo({
                            "name": user.profile.name,
                            "email": user.email,
                            "description": "User_id: " + user.id
                        })
                        Vue.$jivosite.setCustomData([
                            {
                                "title": "user.profile.name",
                                "content": user.profile.name + " ",
                            },
                            {
                                "title": "user.email",
                                "content": user.email + " ",
                            },
                            {
                                "title": "User_id",
                                "content": user.id + " ",
                            },
                        ])
                    }
                }
            }, 4000);
        },
        onFail(error) {
            //console.log('VueJivosite Failed :-(', error)
        }
    })
} */
Vue.component("v-select", vSelect);
Vue.use(VueMeta)
Vue.use(Clipboard)
Vue.use(LoadScript);

if (Vue.prototype.$flavorConfig.ymId) {
    Vue.use(VueYandexMetrika, {
        id: Vue.prototype.$flavorConfig.ymId,
        env: process.env.NODE_ENV,
        options: {clickmap: true, webvisor: true, ecommerce: "dataLayer"},
    })
}
if (Vue.prototype.$flavorConfig.gtmId) {
    Vue.use(VueGtm, {
        id: Vue.prototype.$flavorConfig.gtmId,
        debug: true,
        vueRouter: router,
    });
}
if (Vue.prototype.$flavorConfig.gtagId) {
    Vue.use(VueGtag, {
        config: {id: Vue.prototype.$flavorConfig.gtagId}
    });
}

axios.interceptors.response.use(
    response => response,
    error => {
        if (error && error.response) {
            const {status} = error.response
            if (status === UNAUTHORIZED) {
                console.log('401 UNAUTHORIZED')
                JwtService.destroyUser()
                if (window.location.pathname !== process.env.VUE_APP_PUBLIC_PATH + 'user/login' && window.location.pathname !== process.env.VUE_APP_PUBLIC_PATH + 'user/signin') {
                    router.replace('/user/signin?return=' + window.location.pathname.replace(process.env.VUE_APP_PUBLIC_PATH, '/'))
                    console.log('redirect to user/login from interceptor')
                    //window.location.href = process.env.VUE_APP_PUBLIC_PATH + 'user/login'
                }
            }
        }
        return Promise.reject(error)
    }
)

Vue.mixin({
    data: function () {
        return {
            get flavorConfig() {
                return flavorConfigJson
            },
        }
    },
})

new Vue({
    router,
    i18n,
    render: h => h(App),
    mounted() {
        if (isAuthenticated()) userApi.pushUserContext()
        versionApi
            .fetchVersion()
            .then(response => {
                const version = response
                const currentVersion = CStorage.getItem("versionHASH", "")
                if (currentVersion !== version) {
                    CStorage.setItem("versionHASH", version)
                    console.log("New Version HASH! " + version)
                    console.log("Force page reload!")
                    window.location.reload(true)
                }

            })
            .catch(error => {
                console.log(error)
            })
    }
}).$mount('#app')
